module.exports = __webpack_public_path__ + "img/ErrorV2.d372f9c2.png";